import {EventFunc} from "types/types";
import * as React from "react";
import {CSSProperties} from "react";

interface Props {
  value: string;
  placeholder: string;
  disabled: boolean;
  updateValue: (value: string) => void;
  password?: boolean;
  inputName: string;
  onBlur?: EventFunc;
  invalid?:boolean;
  required?:boolean;
  id?:string;
  className?:string;
  style?:CSSProperties;
}

export const SignupInput = (props: Props) =>
  <input
      id={props.id}
      type={props.password ? 'password' : 'text'}
      value={props.value}
      onChange={e => props.updateValue(e.target.value)}
      placeholder={props.placeholder}
      disabled={props.disabled}
      onBlur={props.onBlur}
      aria-label={props.placeholder}
      aria-invalid={props.invalid}
      aria-required={props.required}
      className={`${props.className?props.className:''} ${props.invalid?'invalid':''}`}
      style={props.style}
  />
;
